// Carrega o SDK do Mercado Pago (v2) uma unica vez.
// Retorna instancia MercadoPago inicializada com REACT_APP_MP_PUBLIC_KEY (build-time env).
let cached = null;
let loading = null;

const PUBLIC_KEY = process.env.REACT_APP_MP_PUBLIC_KEY;

export function isConfigured() {
  return !!PUBLIC_KEY;
}

export function load() {
  if (cached) return Promise.resolve(cached);
  if (loading) return loading;

  loading = new Promise((resolve, reject) => {
    if (!PUBLIC_KEY) {
      loading = null;
      reject(new Error('MP_PUBLIC_KEY nao configurada'));
      return;
    }
    if (window.MercadoPago) {
      cached = new window.MercadoPago(PUBLIC_KEY, { locale: 'pt-BR' });
      resolve(cached);
      return;
    }
    const existing = document.querySelector('script[data-mp-sdk]');
    const script = existing || document.createElement('script');
    if (!existing) {
      script.src = 'https://sdk.mercadopago.com/js/v2';
      script.setAttribute('data-mp-sdk', 'true');
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => {
      try {
        cached = new window.MercadoPago(PUBLIC_KEY, { locale: 'pt-BR' });
        resolve(cached);
      } catch (err) {
        loading = null;
        reject(err);
      }
    });
    script.addEventListener('error', () => {
      loading = null;
      reject(new Error('Falha ao carregar SDK MP'));
    });
  });

  return loading;
}

const mpSdk = { isConfigured, load };
export default mpSdk;
